require('../../modules/es6.string.starts-with');
module.exports = require('../../modules/_core').String.startsWith;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/fn/string/starts-with.js
// module id = 279
// module chunks = 0